import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
  CardContent,
  List,
  Divider,
  ListItem,
  Tooltip,
  Autocomplete,
  Popper,
  Tab,
  Tabs,
  tabsClasses,
  InputAdornment,
  Switch,
  IconButton,
} from "@mui/material";
import { CiSearch } from "react-icons/ci";
import { useStyles } from "../../../theme/appStyles";
import React, { SyntheticEvent, useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Box, Typography } from "@mui/material";
import {
  useRevertManualOrderListMutation,
  useGetCheckManualStatusQuery,
  useGetfilterOrderListHistoryFristQuery,
  useGetOrderListByIdQuery,
  useAdminSetManualPriceOrderListMutation,
  useGetGroupByManualOrderListQuery,
  useGetStoreQuery,
  useGetProductQuery,
  useGetRestaurantQuery,
  useGetUniqueCategoryQuery,
  useGetStoreItemOrderListQuery,
} from "../../../Api/attoDeskApi";
import {
  IOrderListPriceEdit,
  IOrderList,
  IUserAdmin,
  IStore,
  IVariantView,
  IStoreItemAdminEdit,
  IRestaurant,
  CustomerOption,
  ICategory,
  CustomerOptionString,
  IStoreRefItem,
} from "../../../Api/Interface/api.interface";
import { Link, useParams } from "react-router-dom";
import {
  OrderListItemStatus,
  OrderListStatus,
  PRIORITY_COLORS,
  SizeOfLevelType,
  editPriceOrderListStatus,
} from "../../../Core/Enum/enum";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs, { Dayjs } from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../../../Core/Notifier";
import { useFormik } from "formik";
import NewPopUpProduct from "../../Product/Edit/storepriceOnly";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import ReplyIcon from "@mui/icons-material/Reply";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import ClassRoundedIcon from "@mui/icons-material/ClassRounded";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { IoIosImages } from "react-icons/io";
import ReplaceImage from "../../../Images/repImg.png";
import CustomCheckbox from "../../../Components/Checkbox.tsx/CustomCheckbox";
import RefreshIcon from "@mui/icons-material/Refresh";
import useMediaQuery from "@mui/material/useMediaQuery";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    case SizeOfLevelType.lb:
      return "lb";
    default:
      return "";
  }
};

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    case "UpdatedStoreOnly":
      return "Updated Store";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    default:
      return "";
  }
};

const formatUnit = (value: number | string) => {
  const num = Number(value);
  return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
};

const StyledPaper = styled("div")(({ theme }) => ({
  borderRadius: "12px",
  minWidth: 240,
  padding: theme.spacing(1.5),
  backgroundColor: "#ffffff",
  // boxShadow: theme.shadows[6],
}));

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);

const orderListButtonBRadius =
  lightThemeColor?.orderListProp?.buttonRadius || "4px";

interface FormValues {
  orderListId: string;
  storeId: number | null;
  id: number | null;
}

interface RevertFormValues {
  orderListId: string;
  id: number | null;
}

const Index = () => {
  const classes = useStyles();
  const isMobileRes = useIsMobile();
  const theme = useTheme();
  const isMobileResLg = useMediaQuery(theme.breakpoints.down("lg"));

  const [isPaperVisible, setIsPaperVisible] = useState(false);
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: orderListHistoryId } = useParams<{ id: string }>();
  const [orderList, setOrderList] = useState<IOrderListPriceEdit[]>([]);
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );

  const [groupedData, setGroupedData] = useState<
    Record<string, IOrderListPriceEdit[]>
  >({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const navigate = useNavigate();
  const [coursingToStatus, setCoursingToStatus] = useState<string | undefined>(
    ""
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<String | undefined>(
    undefined
  );
  const [selectedProductData, setSelectedProductData] = useState<
    IVariantView | undefined
  >(undefined);
  const [openDialog, setOpenDialog] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPriority, setSelectedPriority] = useState<string>("");
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [loadingRowId, setLoadingRowId] = useState<number | null>(null);
  const [loadingRevertRowId, setLoadingRevertRowId] = useState<number | null>(
    null
  );

  // const {
  //   data: manualStatusData,
  //   isLoading: manualStatusIsLoaing,
  //   isError: manualStatusIsError,
  //   refetch: attananceRefetch,
  // } = useGetCheckManualStatusQuery({ id: 2 }, { pollingInterval: 1000 });

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
    refetch,
  } = useGetfilterOrderListHistoryFristQuery(
    {
      searchText: searchQuery,
      orderId: String(orderListHistoryId),
      priority_status: selectedPriority,
      categoryId: selectedCategoryId,
    },
    { pollingInterval: 15000 }
  );

  const {
    data: orderListupData,
    isLoading: orderListUPIsLoading,
    isError: orderListUpIsError,
    refetch: orderListUpRefetch,
  } = useGetGroupByManualOrderListQuery(
    {
      orderId: String(orderListHistoryId),
      searchText: "",
    },
    { pollingInterval: 15000 }
  );

  const {
    data: orderListCategoryData,
    isLoading: orderListCategoryIsLoading,
    isError: orderListCategoryIsError,
    refetch: orderListCategoryRefetch,
  } = useGetUniqueCategoryQuery(
    {
      id: String(orderListHistoryId),
    },
    { pollingInterval: 15000 }
  );

  const {
    data: variantData,
    isLoading: variantIsLoading,
    isError: variantIsError,
  } = useGetProductQuery({
    searchText: "",
    id: "",
    variantBrandId: null,
    categoryId: null,
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
    mainItemId: null,
  });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
    id: "",
  });

  const [newStatus, { isLoading }] = useAdminSetManualPriceOrderListMutation();
  const [newRevert, { isLoading: revertIsLoading }] =
    useRevertManualOrderListMutation();

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const {
    data: OrderlistEditProductIdDate,
    isLoading: OrderlistEditProductIdIsLoading,
    isError: OrderlistEditProductIdIsErrr,
  } = useGetProductQuery(
    {
      searchText: "",
      id: String(selectedProduct),
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
      mainItemId: null,
    },
    {
      skip: !selectedProduct,
    }
  );

  const {
    data: OrderListMainData,
    isLoading: OrderListMainDDateIsLoading,
    isError: OrderListMainDDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: "",
    id: String(orderListHistoryId),
  });

  const dataProduct = useMemo(() => {
    if (
      OrderlistEditProductIdDate &&
      Array.isArray(OrderlistEditProductIdDate.data) &&
      OrderlistEditProductIdDate.data.length > 0
    ) {
      return OrderlistEditProductIdDate.data[0] as IVariantView;
    }
    return undefined;
  }, [OrderlistEditProductIdDate]);

  useEffect(() => {
    if (dataProduct) {
      setSelectedProductData(dataProduct);
    }
  }, [dataProduct]);

  const categoryList = useMemo(() => {
    return orderListCategoryData?.data as ICategory[];
  }, [orderListCategoryData?.data]);

  const orderListHisrotyRecord = useMemo(() => {
    return orderListData?.data as IOrderListPriceEdit[];
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListMainData?.data as IOrderList[];
  }, [OrderListMainData?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const productList = useMemo(() => {
    return variantData?.data as IVariantView[];
  }, [variantData?.data]);

  const groupedOrderList = useMemo(() => {
    return orderListupData?.data ?? {};
  }, [orderListupData?.data]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, category.storeName);
    });
    return map;
  }, [getAllStoreList]);

  const restaurantMap = useMemo(() => {
    const map = new Map();
    restaurantList?.forEach((category) => {
      map.set(category.id, category.restaurantsName);
    });
    return map;
  }, [restaurantList]);

  const storeOptions = useMemo(() => {
    if (!Array.isArray(getAllStoreList)) return [];
    return getAllStoreList.map((cust) => ({
      label: `${cust.storeName}`,
      value: Number(cust.id),
    }));
  }, [getAllStoreList]);

  const catgoryOptions = useMemo(() => {
    if (!Array.isArray(categoryList)) return [];
    return categoryList.map((cust) => ({
      label: `${cust.categoryName}`,
      value: Number(cust.id),
    }));
  }, [categoryList]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryList]);

  const reminderBeforOptions: CustomerOptionString[] = Object.values(
    OrderListItemStatus
  ).map((day) => ({
    label: day,
    value: day,
  }));

  const variantMap = useMemo(() => {
    const map = new Map<
      string,
      {
        name: string;
        displayname: string;
        variantImg: string;
        variantRefNumber: string;
        variantUnit: number;
        categoryName: string | null;
      }
    >();

    productList?.forEach((teamMember) => {
      const categoryName = categoryMap.get(teamMember.categoryId) || null;
      map.set(teamMember.id, {
        name: teamMember.variantName,
        variantRefNumber: teamMember.variantRefNumber,
        variantImg: teamMember.variantImg,
        variantUnit: teamMember.variantUnit,
        displayname: teamMember.variantDisplayName,
        categoryName,
      });
    });

    return map;
  }, [productList]);

  const handleMainCategoryChange = (event: SyntheticEvent, value: any) => {
    const categoryId = value as number;
    setSelectedCategoryId(categoryId);
  };

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;
  const branchId =
    orderListDate?.length > 0 ? orderListDate[0].restaurantsId : null;
  const orderListStatus =
    orderListDate?.length > 0 ? orderListDate[0].orderListStatus : null;

  const handleCloseDialog = () => {
    setSelectedProduct(undefined);
    setOpenDialog(false);
    setSelectedProductData(undefined);
    refetch();
  };

  useEffect(() => {
    if (orderListHisrotyRecord) {
      setOrderList(orderListHisrotyRecord);
    }
  }, [orderListHisrotyRecord]);

  const confirmFormik = useFormik<FormValues>({
    initialValues: {
      orderListId: "",
      storeId: null,
      id: null,
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          orderListId: String(orderListHistoryId),
          storeId: values.storeId,
          id: values.id,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const handleConfirm = async (checked: boolean, row: IOrderListPriceEdit) => {
    if (!confirmFormik.values.storeId) {
      showErrorMessage("Please select store first");
      return;
    }

    if (!checked) return;
    if (row.id) {
      setLoadingRowId(row.id);
      try {
        const temData = {
          orderListId: String(orderListHistoryId),
          storeId: confirmFormik.values.storeId,
          id: row.id,
        };
        if (!temData.orderListId) {
          showErrorMessage("Please set Order List");
          return;
        }

        const addCompanyResponse = await newStatus(temData).unwrap();

        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);

          confirmFormik.setValues({
            orderListId: String(orderListHistoryId),
            storeId: confirmFormik.values.storeId,
            id: row.id,
          });
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      } finally {
        setLoadingRowId(null);
      }
    }
  };

  const revertFormik = useFormik<RevertFormValues>({
    initialValues: {
      orderListId: "",
      id: null,
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          orderListId: String(orderListHistoryId),
          id: values.id,
        };

        const addCompanyResponse = await newRevert(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const handleRevertConfirm = async (rowId: number) => {
    if (!rowId) return;

    setLoadingRevertRowId(rowId);

    try {
      const temData = {
        orderListId: String(orderListHistoryId),
        id: rowId,
      };

      if (!temData.orderListId) {
        showErrorMessage("Please set Order List");
        return;
      }

      const addCompanyResponse = await newRevert(temData).unwrap();

      if (!addCompanyResponse.status) {
        showErrorMessage(addCompanyResponse.message);
      } else {
        showMessage(addCompanyResponse.message);

        revertFormik.setValues({
          orderListId: String(orderListHistoryId),
          id: rowId,
        });
      }
    } catch (error) {
      showErrorMessage("Something went wrong");
    } finally {
      setLoadingRevertRowId(null);
    }
  };

  // React.useEffect(() => {
  //   if (manualStatusData?.active_status == "1") {
  //     refetch();
  //     orderListUpRefetch();
  //     orderListCategoryRefetch();
  //   }
  // }, [manualStatusData, refetch]);

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  const resetFields = () => {
    setSelectedCategoryId(null);
    setSearchQuery("");
    setSelectedPriority("");
  };

  // if (
  //   OrderListDateIsLoading ||
  //   storeIsLoading ||
  //   restauramtIsLoading
  // ) {
  //   return (
  //     <Box
  //       display="flex"
  //       justifyContent="center"
  //       alignItems="center"
  //       height="10vh"
  //     >
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  return (
    <Grid container spacing={3}>
      <Grid item lg={8} md={12} sm={12} xs={12}>
        <Card
          className={
            isMobileResLg
              ? classes.orderListLeftCardViewNotHight
              : classes.orderListLeftCardView
          }
          sx={{ height: "100%" }}
        >
          <Grid
            container
            justifyContent={"space-between"}
            spacing={2}
            sx={{ padding: 2, borderBottom: 1 }}
            className={classes.orderListLeftHeader}
          >
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Typography className={classes.OLLeftHeading}>
                    Updated Card
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Autocomplete
                options={storeOptions}
                loading={storeIsLoading}
                getOptionLabel={(option: CustomerOption) => option.label}
                value={
                  storeOptions.find(
                    (opt) => opt.value === Number(confirmFormik.values.storeId)
                  ) || null
                }
                onChange={(_, newValue: CustomerOption | null) => {
                  confirmFormik.setFieldValue("storeId", newValue?.value || "");
                }}
                PopperComponent={(props) => (
                  <Popper
                    {...props}
                    placement="bottom-start"
                    // sx={{ zIndex: 1300 }}
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <Box
                    component="li"
                    {...props}
                    sx={{
                      p: 1.5,
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontWeight: 600,
                      mb: 1,
                      transition: "0.2s",

                      backgroundColor: "#f5f5f5",
                      color: "#333",

                      "&.Mui-selected": {
                        backgroundColor:
                          theme.palette.primary.main + " !important",
                        color:
                          theme.palette.primary.contrastText + " !important",
                      },

                      "&.Mui-selected:hover": {
                        backgroundColor: "#1565c0 !important",
                      },

                      "&:hover": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                  >
                    {option.label}
                  </Box>
                )}
                renderInput={(params) => {
                  const hasValue = Boolean(params.inputProps.value);

                  return (
                    <TextField
                      {...params}
                      placeholder="Select Store"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: orderListButtonBRadius,
                          backgroundColor: hasValue
                            ? theme.palette.orderListProp.buttonBgColor
                            : theme.palette.orderListProp.buttonBgColor,
                          color: hasValue
                            ? theme.palette.orderListProp.buttonIconColor
                            : theme.palette.orderListProp.buttonIconColor,
                          transition: "all 0.2s ease-in-out",

                          "& fieldset": {
                            // borderColor: hasValue
                            //   ? "#1976d2"
                            //   : "#d1d5db",
                          },
                          "&:hover fieldset": {
                            // borderColor: "#1976d2",
                          },
                          "&.Mui-focused fieldset": {
                            // borderColor: "#1976d2",
                            // borderWidth: "2px",
                          },
                        },
                        "& input": {
                          // fontSize: "16px",
                          fontWeight: 600,
                          color: hasValue
                            ? theme.palette.orderListProp.buttonIconColor
                            : theme.palette.orderListProp.buttonIconColor,
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {storeIsLoading && <CircularProgress size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  );
                }}
                PaperComponent={(props) => <StyledPaper {...props} />}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid
              item
              lg={8}
              md={7}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    startIcon={<FilterAltIcon />}
                    className={classes.ordeListButton}
                    onClick={handleToggle}
                  >
                    {isPaperVisible ? "Close Filter" : "Open Filter"}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    // variant="contained"
                    startIcon={<RefreshIcon />}
                    className={classes.ordeListButton}
                    onClick={resetFields}
                  >
                    Refresh
                  </Button>
                </Grid>
                <Grid item>
                  <Link
                    to={
                      orderListStatus === "ManagerApproved"
                        ? `/order/list/view/${orderListHistoryId}`
                        : `/order/list/set/price/list/${orderListHistoryId}`
                    }
                    className={classes.iconLinkPropNormal}
                  >
                    <Button
                      startIcon={<ReplyIcon />}
                      className={classes.ordeListConfirmButton}
                    >
                      Back
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {isPaperVisible && (
            <>
              <Grid
                container
                spacing={2}
                my={2}
                px={1}
                sx={{ padding: 2 }}
                className={classes.orderListLeftHeader}
              >
                <Grid item lg={3} md={4} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Category
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={catgoryOptions}
                        loading={orderListCategoryIsLoading}
                        getOptionLabel={(option: CustomerOption) =>
                          option.label
                        }
                        value={
                          catgoryOptions.find(
                            (opt) => opt.value === Number(selectedCategoryId)
                          ) || null
                        }
                        onChange={(_, newValue: CustomerOption | null) => {
                          setSelectedCategoryId(
                            newValue ? newValue.value : null
                          );
                        }}
                        PopperComponent={(props) => (
                          <Popper {...props} placement="bottom-start" />
                        )}
                        renderOption={(props, option, { selected }) => (
                          <Box
                            component="li"
                            {...props}
                            sx={{
                              p: 1.5,
                              borderRadius: "10px",
                              cursor: "pointer",
                              fontWeight: 600,
                              mb: 1,
                              transition: "0.2s",

                              backgroundColor: "#f5f5f5",
                              color: "#333",

                              "&.Mui-selected": {
                                backgroundColor:
                                  theme.palette.primary.main + " !important",
                                color:
                                  theme.palette.primary.contrastText +
                                  " !important",
                              },

                              "&.Mui-selected:hover": {
                                backgroundColor: "#1565c0 !important",
                              },

                              "&:hover": {
                                backgroundColor: "#e0e0e0",
                              },
                            }}
                          >
                            {option.label}
                          </Box>
                        )}
                        renderInput={(params) => {
                          const hasValue = Boolean(params.inputProps.value);

                          return (
                            <TextField
                              {...params}
                              placeholder="Select Store"
                              size="small"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: orderListButtonBRadius,
                                  backgroundColor: hasValue
                                    ? theme.palette.orderListProp.buttonBgColor
                                    : theme.palette.orderListProp.buttonBgColor,
                                  color: hasValue
                                    ? theme.palette.orderListProp
                                        .buttonIconColor
                                    : theme.palette.orderListProp
                                        .buttonIconColor,
                                  transition: "all 0.2s ease-in-out",

                                  "& fieldset": {
                                    // borderColor: hasValue
                                    //   ? "#1976d2"
                                    //   : "#d1d5db",
                                  },
                                  "&:hover fieldset": {
                                    // borderColor: "#1976d2",
                                  },
                                  "&.Mui-focused fieldset": {
                                    // borderColor: "#1976d2",
                                    // borderWidth: "2px",
                                  },
                                },
                                "& input": {
                                  // fontSize: "16px",
                                  fontWeight: 600,
                                  color: hasValue
                                    ? theme.palette.orderListProp
                                        .buttonIconColor
                                    : theme.palette.orderListProp
                                        .buttonIconColor,
                                },
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {orderListCategoryIsLoading && (
                                      <CircularProgress size={20} />
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          );
                        }}
                        PaperComponent={(props) => <StyledPaper {...props} />}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={3} md={4} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Priority
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={reminderBeforOptions}
                        getOptionLabel={(option: CustomerOptionString) =>
                          option.label
                        }
                        value={
                          reminderBeforOptions.find(
                            (opt) => opt.value === String(selectedPriority)
                          ) || null
                        }
                        onChange={(
                          _,
                          newValue: CustomerOptionString | null
                        ) => {
                          setSelectedPriority(newValue ? newValue.value : "");
                        }}
                        PopperComponent={(props) => (
                          <Popper {...props} placement="bottom-start" />
                        )}
                        renderOption={(props, option, { selected }) => (
                          <Box
                            component="li"
                            {...props}
                            sx={{
                              p: 1.5,
                              borderRadius: "10px",
                              cursor: "pointer",
                              fontWeight: 600,
                              mb: 1,
                              transition: "0.2s",

                              backgroundColor: "#f5f5f5",
                              color: "#333",

                              "&.Mui-selected": {
                                backgroundColor:
                                  theme.palette.primary.main + " !important",
                                color:
                                  theme.palette.primary.contrastText +
                                  " !important",
                              },

                              "&.Mui-selected:hover": {
                                backgroundColor: "#1565c0 !important",
                              },

                              "&:hover": {
                                backgroundColor: "#e0e0e0",
                              },
                            }}
                          >
                            {option.label}
                          </Box>
                        )}
                        renderInput={(params) => {
                          const hasValue = Boolean(params.inputProps.value);

                          return (
                            <TextField
                              {...params}
                              placeholder="Select Store"
                              size="small"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: orderListButtonBRadius,
                                  backgroundColor: hasValue
                                    ? theme.palette.orderListProp.buttonBgColor
                                    : theme.palette.orderListProp.buttonBgColor,
                                  color: hasValue
                                    ? theme.palette.orderListProp
                                        .buttonIconColor
                                    : theme.palette.orderListProp
                                        .buttonIconColor,
                                  transition: "all 0.2s ease-in-out",

                                  "& fieldset": {
                                    // borderColor: hasValue
                                    //   ? "#1976d2"
                                    //   : "#d1d5db",
                                  },
                                  "&:hover fieldset": {
                                    // borderColor: "#1976d2",
                                  },
                                  "&.Mui-focused fieldset": {
                                    // borderColor: "#1976d2",
                                    // borderWidth: "2px",
                                  },
                                },
                                "& input": {
                                  // fontSize: "16px",
                                  fontWeight: 600,
                                  color: hasValue
                                    ? theme.palette.orderListProp
                                        .buttonIconColor
                                    : theme.palette.orderListProp
                                        .buttonIconColor,
                                },
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {storeIsLoading && (
                                      <CircularProgress size={20} />
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          );
                        }}
                        PaperComponent={(props) => <StyledPaper {...props} />}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={6} md={4} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Search Name & Display Name
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CiSearch
                                className={classes.orderListSearchWidgetIcon}
                              />
                            </InputAdornment>
                          ),
                          classes: {
                            root: classes.formControlList,
                          },
                        }}
                        fullWidth
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Name & Display Name.."
                        className={classes.orderListTextField}
                        size="small"
                        // sx={{ minWidth: "300px" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          <Grid container justifyContent={"space-between"} spacing={2}>
            {/* {isPaperVisible && ( */}
            <Grid item lg={12} md={12} sm={12} xs={12} alignContent={"center"}>
              <Box>
                <Tabs
                  value={selectedCategoryId || ""}
                  onChange={handleMainCategoryChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="scrollable force tabs example"
                  sx={{
                    borderBottom: 1,
                    borderTop: isPaperVisible ? 1 : "none",
                    [`& .${tabsClasses.scrollButtons}`]: {
                      "&.Mui-disabled": { opacity: 0.3 },
                    },
                    "& .MuiTabs-scrollButtons svg": {
                      fontSize: 40,
                      color: "black",
                    },
                  }}
                  className={classes.orderListRightHeader2}
                >
                  {categoryList &&
                    categoryList.map((category) => (
                      <Tab
                        key={category.id}
                        value={category.id}
                        label={
                          <Box
                            className={
                              selectedCategoryId === category.id
                                ? classes.orderListTabButtonSelect
                                : classes.orderListTabButton
                            }
                          >
                            <ClassRoundedIcon />
                            <Typography
                              sx={{
                                px: 1,
                              }}
                              className={classes.tabTypograpy}
                            >
                              {category.categoryName}
                            </Typography>
                          </Box>
                        }
                      />
                    ))}
                </Tabs>
              </Box>
            </Grid>
            {/* )} */}

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container justifyContent={"space-between"} spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      maxHeight: "90vh",
                      overflow: "auto",
                      // padding: "2px",
                      width: "100%",
                      "&::-webkit-scrollbar": {
                        width: "4px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#eeeeee",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#eeeeee",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#eeeeee",
                      },
                    }}
                  >
                    <TableContainer>
                      <Table className={classes.table}>
                        <TableBody>
                          {orderListIsLoading ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  height="10vh"
                                >
                                  <CircularProgress />
                                </Box>
                              </TableCell>
                            </TableRow>
                          ) : orderListIsError ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                <Typography className={classes.leftORTypo}>
                                  Some thing went to wrong
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ) : orderList.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                <Typography className={classes.leftORTypo}>
                                  No data available
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ) : (
                            orderList.map((row: IOrderListPriceEdit, index) => {
                              const storeMiniName =
                                getStoreMap.get(
                                  row?.minimumpriceDetails?.storeId
                                ) || "";
                              return (
                                <TableRow
                                  key={index}
                                  className={classes.tableRowHover}
                                >
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    sx={{ width: "30px" }}
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    <Link
                                      to={`/variant/view/${row.productId}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Grid
                                        container
                                        alignItems="center"
                                        spacing={1}
                                      >
                                        <Grid item xs="auto">
                                          <Box
                                            className={
                                              classes.SelectImageTableBoxwithBorder
                                            }
                                          >
                                            {(row?.productId &&
                                              variantMap.get(row?.productId)
                                                ?.variantImg) ||
                                            ReplaceImage ? (
                                              <img
                                                src={
                                                  variantMap.get(row.productId)
                                                    ?.variantImg || ReplaceImage
                                                }
                                                alt="img"
                                                className={
                                                  classes.SelectImageTable
                                                }
                                                onError={(e) =>
                                                  (e.currentTarget.src =
                                                    ReplaceImage)
                                                }
                                              />
                                            ) : (
                                              <IoIosImages
                                                className={
                                                  classes.SelectImageTable
                                                }
                                              />
                                            )}
                                          </Box>
                                        </Grid>

                                        <Grid item xs>
                                          <Typography
                                            className={classes.leftORTypo}
                                          >
                                            {row.variantName}
                                          </Typography>
                                          {variantMap.get(row.productId)
                                            ?.variantRefNumber && (
                                            <Typography
                                              className={classes.leftORTypo11}
                                            >
                                              {`Ref No : ${
                                                variantMap.get(row.productId)
                                                  ?.variantRefNumber
                                              }`}
                                            </Typography>
                                          )}
                                          {row.priority_status && (
                                            <Typography
                                              // className={classes.leftORTypo}
                                              sx={{
                                                fontWeight: 600,
                                                fontSize: "12px",
                                                color:
                                                  PRIORITY_COLORS[
                                                    row?.priority_status || ""
                                                  ],
                                              }}
                                            >
                                              {row.priority_status}
                                            </Typography>
                                          )}
                                          {isMobileRes &&
                                            variantMap.get(row.productId)
                                              ?.categoryName && (
                                              <Typography
                                                className={classes.leftORTypo11}
                                              >
                                                {`Category : ${
                                                  variantMap.get(row.productId)
                                                    ?.categoryName
                                                }`}
                                              </Typography>
                                            )}
                                        </Grid>
                                      </Grid>
                                    </Link>
                                  </TableCell>
                                  {!isMobileRes && (
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      <Typography
                                        className={classes.leftORTypo}
                                      >
                                        {
                                          variantMap.get(row.productId)
                                            ?.categoryName
                                        }
                                      </Typography>
                                    </TableCell>
                                  )}
                                  <TableCell
                                    className={classes.tablCell}
                                    sx={{
                                      textAlign: "center",
                                      minWidth: 80,
                                    }}
                                  >
                                    {isLoading &&
                                    confirmFormik.values.id === row.id ? (
                                      <CircularProgress size={20} />
                                    ) : (
                                      <CustomCheckbox
                                        checked={
                                          confirmFormik.values.id === row.id
                                        }
                                        disabled={isLoading}
                                        onChange={(e) =>
                                          handleConfirm(e.target.checked, row)
                                        }
                                      />
                                    )}

                                    {/* <CustomCheckbox
                                      checked={
                                        confirmFormik.values.id === row.id
                                      }
                                      // disabled={
                                      //   !confirmFormik.values.storeId ||
                                      //   loadingRowId !== null
                                      // }
                                      onChange={(e) =>
                                        handleConfirm(e.target.checked, row)
                                      }
                                    /> */}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  {selectedProduct && selectedProductData && (
                    <NewPopUpProduct
                      openModel={openDialog}
                      handleCloseDialog={handleCloseDialog}
                      // OrderlistEditProductId={selectedProduct}
                      data={selectedProductData}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      <Grid item lg={4} md={12} sm={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card
              className={classes.orderListRightCard}
              sx={{ height: "100%" }}
            >
              <Grid container spacing={2} p={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container justifyContent={"space-between"} spacing={1}>
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-start"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <Typography className={classes.OLLeftHeading}>
                            {ReDateId}
                          </Typography>
                          <Typography className={classes.OLLeftHeading}>
                            {convertStatus(orderListStatus || "")}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <Typography
                            textAlign={"right"}
                            className={classes.OLLeftHeading}
                          >
                            {restaurantMap.get(branchId) || ""}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={3} mt={3}>
                    {orderListUPIsLoading ? (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="10vh"
                        >
                          <CircularProgress />
                        </Box>
                      </Grid>
                    ) : orderListUpIsError ? (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          textAlign={"center"}
                          className={classes.leftORTypo}
                        >
                          Some thing went to wrong
                        </Typography>
                      </Grid>
                    ) : Object.keys(groupedOrderList).length === 0 ? (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          textAlign={"center"}
                          className={classes.leftORTypo}
                        >
                          No data available
                        </Typography>
                      </Grid>
                    ) : (
                      Object.entries(groupedOrderList).map(
                        ([storeId, orders]) => {
                          const storeName =
                            storeId === undefined || storeId === null
                              ? "Update Items Price to Supplier"
                              : getStoreMap.get(Number(storeId)) ||
                                "Supplier Not Found";
                          return (
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              key={storeId}
                              pb={2}
                            >
                              <Card
                                sx={{
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  borderRadius: 3,
                                  boxShadow: "none",
                                  border: `1px solid #d8dfe7`,
                                  transition: "0.3s ease-in-out",
                                  "&:hover": {
                                    backgroundColor: "#ffffff",
                                    borderRadius: "10px",
                                    border: "0.5px solid #ffffff",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                  },
                                }}
                              >
                                <CardContent
                                  sx={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    fontWeight="bold"
                                    gutterBottom
                                    className={classes.orderLsitHeadingTypoView}
                                    style={{
                                      fontWeight: "bold",
                                      color: "#007bff",
                                    }}
                                  >
                                    {storeName}
                                  </Typography>

                                  <List sx={{ flexGrow: 1 }}>
                                    {orders.map((order, index) => (
                                      <React.Fragment key={order.id}>
                                        <ListItem
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            px: 2,
                                            py: 1,
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontWeight: "bold",
                                              color: "#1a202c",
                                              flex: 1,
                                              textAlign: "left",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <Link
                                              to={`/variant/view/${order.productId}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              {order.variantName}{" "}
                                            </Link>
                                          </Typography>
                                          <Typography
                                            sx={{
                                              color: "#28a745",
                                              fontWeight: "bold",
                                              flex: 1,
                                              textAlign: "center",
                                            }}
                                          >
                                            {formatUnit(order.productTotalUnit)}{" "}
                                            {convertUnit(order.variantUnit)}
                                          </Typography>
                                          {revertIsLoading &&
                                          revertFormik.values.id ===
                                            order.id ? (
                                            <CircularProgress size={20} />
                                          ) : (
                                            <Button
                                              className={classes.editButtonList}
                                              disabled={revertIsLoading}
                                              onClick={() =>
                                                handleRevertConfirm(order.id)
                                              }
                                            >
                                              <RefreshIcon
                                                className={classes.editListIcon}
                                              />
                                            </Button>
                                          )}
                                        </ListItem>
                                        <Divider />
                                      </React.Fragment>
                                    ))}
                                  </List>
                                </CardContent>
                              </Card>
                            </Grid>
                          );
                        }
                      )
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Index;
